import { create } from "zustand"

export interface NotificationCommands {
	current: { title: string; unread: boolean } | null
	toggleRead: () => void
	remove: () => void
	markAllRead: () => void
	deleteAll: () => void
	deleteRead: () => void
	deleteCompleted: () => void
}

/** What the command menu can do on the Notifications page; null everywhere else. */
export const useNotificationCommands = create<{
	commands: NotificationCommands | null
}>()(() => ({ commands: null }))
